<template>
  <fragment>
    <light-header></light-header>

    <section>
      <div class="container">
        <div class="columns  ">
          <div class="column is-4 is-offset-1" v-if="type === 'reg'">
            <div class="sep-32"></div>
            <div class="title-lg">
              Welcome! You are now officially a member of the Startup Falcon community.
            </div>
            <div class="sep-32"></div>
            <div class="body">
              <strong>
                Your free plan subscription gets you: 2 FREE valuations each month!
              </strong>
              If we are able to impress you then, you can upgrade to access:
              <div class="sep-24"></div>
              <ul class="disc">
                <li>Full valuation results, charts, graphs.</li>
                <li>Professional, downloadable, valuation reports.</li>
                <li>Valuation benchmarking statistics.</li>
              </ul>
              <div class="sep-24"></div>
              Let's get started!
            </div>
            <div class="sep-64"></div>
             <div>
              <router-link :to="{'name': 'new_valuation'}"
                           class="button is-fullwidth is-primary">
                Start Valuation
              </router-link>

            </div>
            <div class="sep-24"></div>
            <div class="columns is-centered">
              <div class="column text-center">
                <router-link :to="{'name': 'dashboard'}"
                             class=" is-text">
                 or Go to Dashboard
                </router-link>
              </div>
            </div>
          </div>
          <div class="column is-4 is-offset-1" v-if="type === 'stp'">
            <div class="sep-32"></div>
            <div class="title-lg">
              Congratulations! <br> Now you have the ultimate tool to help you surpass your fundraising goals!
            </div>
            <div class="sep-32"></div>
            <div class="body">
              <ul class="disc">
                <li>Perform valuations with unprecedented ease.</li>
                <li>Full analysis of your valuation.</li>
                <li>Access valuation data for similar startups.</li>
              </ul>
              <div class="sep-24"></div>
              Let’s get this show on the road!
            </div>
            <div class="sep-64"></div>
            <div>
              <router-link :to="{'name': 'new_valuation'}"
                           class="button is-fullwidth is-primary">
                Start Valuation
              </router-link>

            </div>
            <div class="sep-24"></div>
            <div class="columns is-centered">
              <div class="column text-center">
                <router-link :to="{'name': 'dashboard'}"
                             class=" is-text">
                  Go to Dashboard
                </router-link>
<!--                - -->
<!--                <router-link :to="{'name': 'ics_calculator'}"-->
<!--                             class=" is-text">-->
<!--                  Benchmarking Data-->
<!--                </router-link>-->
              </div>
            </div>

          </div>
          <div class="column is-4 is-offset-1" v-if="type === 'ent'">
            <div class="sep-32"></div>
            <div class="title-lg">
              Congratulations! <br> Now you have the ultimate tool to help you surpass your investment goals!
            </div>
            <div class="sep-32"></div>
            <div class="body">
              <ul class="disc">
                <li>Perform multiple valuations in no time.</li>
                <li>Get a full overview of each startup.</li>
                <li>Standardise comparison between opportunities.</li>
              </ul>
              <div class="sep-24"></div>
              Let’s get this show on the road!
            </div>
            <div class="sep-64"></div>
            <div>
              <router-link :to="{'name': 'new_valuation'}"
                           class="button is-fullwidth is-primary">
                Start Valuation
              </router-link>

            </div>
            <div class="sep-24"></div>
            <div class="columns is-centered">
              <div class="column text-center">
                <router-link :to="{'name': 'dashboard'}"
                             class=" is-text">
                  Go to Dashboard
                </router-link>
<!--                - -->
<!--                <router-link :to="{'name': 'ics_calculator'}"-->
<!--                             class=" is-text">-->
<!--                  Benchmarking Data-->
<!--                </router-link>-->
              </div>
            </div>

          </div>
          <div class="column is-5 is-offset-1 onboarding-charts">

          </div>
        </div>
      </div>
    </section>
  </fragment>


</template>

<script>
import {LoginAPI} from "../../../apis/LoginAPI";
import {mapActions} from "vuex";
import LoginHeader from "../../../shared/components/LoginHeader";
import {FormValidation} from "../../../shared/directives/formValidation";
import GoogleLogin from "../components/GoogleLogin";
import FacebookLogin from "../components/FacebookLogin";
import LightHeader from "../../../shared/components/LightHeader";

export default {
  props: {},
  components: {LoginHeader, LightHeader},
  data() {
    return {
      reportData: {},
      type: 'reg'
    }
  },
  mounted() {
    this.type = this.$route.query.type || 'reg';
  },
  methods: {
    async login() {

    },
  },
};
</script>

<style scoped lang="scss">
/*@import "../../../style/index";*/

.body {
  font-size: 16px;
}

.onboarding-charts {
  margin-top: 9px;
  overflow: hidden;
  min-height: calc(100vh - 56px);
  /*padding-top: 29px;*/
  background-color: #E3E9EA;
  //top: -20px;
  position: relative;
  background-size: contain;
  background-position: top right;
  background-repeat: no-repeat;
  background-image: url("../../../images/onboardingcharts.png");
}
</style>
